import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Grid3x3, List, Sidebar } from "lucide-react";
import { useId } from "react";
import { useTranslation } from "react-i18next";
import {
    pillToggleGroupClassName,
    pillToggleItemClassName,
    pillToggleLabelClassName,
} from "./pillToggle";

export enum MailView {
    LIST = "list",
    GRID = "grid",
    SIDE_LIST = "side-list",
}

interface MailViewToggleProps {
    view: MailView;
    onChange: (view: MailView) => void;
    hideSideListMode?: boolean;
    /** Colonne étroite de la liste latérale : icônes seules, « Type d'affichage » au survol. */
    compact?: boolean;
}

const MailViewToggle = ({
    view,
    onChange,
    hideSideListMode,
    compact,
}: MailViewToggleProps) => {
    const { t } = useTranslation();
    const labelId = useId();

    const handleChange = (value: MailView | "") => {
        if (!value) return;
        onChange(value);
    };

    return (
        <div
            className="flex flex-wrap items-center gap-x-2 gap-y-1"
            title={compact ? t("mailViewToggle.label") : undefined}
        >
            <span
                className={compact ? "sr-only" : pillToggleLabelClassName}
                id={labelId}
            >
                {t("mailViewToggle.label")}
            </span>
            <ToggleGroup
                aria-labelledby={labelId}
                className={pillToggleGroupClassName}
                onValueChange={handleChange}
                type="single"
                value={view}
            >
                <ToggleGroupItem
                    aria-label="Vue liste"
                    className={pillToggleItemClassName}
                    value={MailView.LIST}
                >
                    <List />
                </ToggleGroupItem>
                <ToggleGroupItem
                    aria-label="Vue mosaïque"
                    className={pillToggleItemClassName}
                    value={MailView.GRID}
                >
                    <Grid3x3 />
                </ToggleGroupItem>
                {!hideSideListMode && (
                    <ToggleGroupItem
                        aria-label="Vue liste latérale"
                        className={pillToggleItemClassName}
                        value={MailView.SIDE_LIST}
                    >
                        <Sidebar />
                    </ToggleGroupItem>
                )}
            </ToggleGroup>
        </div>
    );
};

export default MailViewToggle;
